module.exports = __webpack_public_path__ + "images/apple-touch-icon-114x114.980088e234b082a231935219076d8994.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/favicons/apple-touch-icon-114x114.png
// module id = 988
// module chunks = 0